
export function detectDevicePlatform() {
  const userAgent = navigator.userAgent;
  const platform = navigator.platform;
  const ios = /iPad|iPhone|iPod/.test(platform)
  const isIOS16Plus = ios && (parseFloat(navigator.userAgent.substring(navigator.userAgent.indexOf("OS ") + 3).replace(' like Mac OS X', '')) >= 16)
  const isIOS18Plus = ios && (parseFloat(navigator.userAgent.substring(navigator.userAgent.indexOf("OS ") + 3).replace(' like Mac OS X', '')) >= 18)
  const isIPadPro = ios && navigator.userAgent.includes('iPad'); // Added this property
  const android = /Android/.test(userAgent);

  return {
    isIOS: ios,
    isIOS16Plus: isIOS16Plus,
    isIOS18Plus: isIOS18Plus,
    isAndroid: android,
    isIPadPro: isIPadPro, // Return this property
    userAgent: userAgent,
    platform: platform
  };
}

export function isMobileDevice(): boolean {
  if (typeof window === 'undefined') return false;
  
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  
  // Check for mobile user agent patterns
  const mobilePatterns = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
    /Opera Mini/i,
    /IEMobile/i,
    /Mobile/i
  ];
  
  // Exclude desktop Safari which sometimes has "Mobile" in UA when using dev tools
  const isDesktopSafari = /Macintosh/.test(userAgent) && /Safari/.test(userAgent) && !/Chrome/.test(userAgent);
  
  if (isDesktopSafari && !/Mobile/.test(userAgent)) {
    return false;
  }
  
  return mobilePatterns.some(pattern => pattern.test(userAgent));
}

export function isInWalletBrowser(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const userAgent = navigator.userAgent.toLowerCase();

  // Check for Phantom Wallet
  if (userAgent.includes('phantom')) {
    return true;
  }

  // Check for Solflare Wallet
  if (userAgent.includes('solflare')) {
    return true;
  }

  // Check for other common wallet indicators
  const indicators = [
    'trustwallet',
    'safepal',
    'metamask',
    'coinbase',
    'binance',
    'exodus',
    'atomicwallet',
  ];

  return indicators.some(indicator => userAgent.includes(indicator));
}

export function isIPadProIOS18(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const devicePlatform = detectDevicePlatform();
  return devicePlatform.isIOS && devicePlatform.isIOS18Plus && navigator.userAgent.includes('iPad');
}

// Export this function
export function isIOS16OrHigher(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  
  const devicePlatform = detectDevicePlatform();
  return devicePlatform.isIOS16Plus;
}

export function useWalletDeviceDetection() {
  return {
    isIPadProIOS18,
    isInWalletBrowser
  };
}
